import React from 'react';
import { FantasyHeader, } from './fantasyHeader';
import { FantasyFooter, } from './fantasyFooter';
import { FantasyTournament, } from './fantasyTournament';


const BLOCK_NAME = 'fantasy';

export default class FantasyComponent extends React.Component {

  get tournamentsList(){
    const {
      tournaments,
      numVisibleTournaments,
      selectTournament,
    } = this.props;
    return tournaments
      .slice(0, numVisibleTournaments)
      .map(function(item, i){
        return (
          <FantasyTournament
            key={ i }
            blockName={ BLOCK_NAME }
            tournament={ item }
            onSelectTournament={ selectTournament }
          />
        );
      });
  }

  get loadingProgressComponent(){
    return <div className={ `${ BLOCK_NAME }__loading` }></div>;
  }

  get fantasyComponent(){
    const {
      loadMoreTournaments,
      isLoadMoreVisible,
    } = this.props;
    const blockClassNames = BLOCK_NAME + (isLoadMoreVisible ? '' :
      ` ${ BLOCK_NAME }--load-more-invisible`);
    return (
      <section
        className={ blockClassNames }
      >
        <FantasyHeader blockName={ BLOCK_NAME }/>
        <ul className={ `${ BLOCK_NAME }__tournament-list` }>
          { this.tournamentsList }
        </ul>
        <FantasyFooter
          blockName={ BLOCK_NAME }
          isLoadMoreVisible={ isLoadMoreVisible }
          onLoadMoreClicked={ loadMoreTournaments }
        />
      </section>
    );
  }

  render(){
    const {
      isInitialized,
      getTournamentsFeed,
      tournaments,
    } = this.props;
    if (!isInitialized) {
      getTournamentsFeed();
      return this.loadingProgressComponent;
    }
    if (!tournaments.length) {
      return false;
    }
    return this.fantasyComponent;
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/components/fantasyComponent.js